import { lazy } from 'react';
import { authRoles } from 'app/auth';

const CommandCentreOverviewView = lazy(() => import('./use-cases/CommandCentreOverview'));

const CommandCentreConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            organisationSelector: false,
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'command-centre',
      element: <CommandCentreOverviewView />,
    },
  ],
};

export default CommandCentreConfig;
